import React, { useState, useEffect, useRef } from 'react';
import useWindowSize from './WindowSize';

function StringCarousel({ items, interval = 3000 }) {
  const [visibleIndex, setVisibleIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false); // Track hover state
  const [width] = useWindowSize();
  const containerRef = useRef(null);
  let itemsPerSlide = 3;

  // Determine the number of items per slide based on the screen width
  if (width < 1070) {
    itemsPerSlide = 1;
  } else if (width >= 1070 && width < 1605) {
    itemsPerSlide = 3;
  } else if (width >= 1605) {
    itemsPerSlide = 4;
  }

  // Automatically update the visibleIndex to show the next set of items unless hovered
  useEffect(() => {
    if (!isHovered) {
      const slideInterval = setInterval(() => {
        setVisibleIndex((prevIndex) => (prevIndex + 1) % Math.ceil(items.length / itemsPerSlide));
      }, interval);

      return () => clearInterval(slideInterval);
    }
  }, [items.length, interval, itemsPerSlide, isHovered]);

  // Update the visible slide based on the current visibleIndex
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.style.transform = `translateX(${-(visibleIndex * 100)}%)`;
    }
  }, [visibleIndex]);

  // Group items into slides
  const groupedItems = [];
  for (let i = 0; i < items.length; i += itemsPerSlide) {
    groupedItems.push(items.slice(i, i + itemsPerSlide));
  }

  // Handle dot click to go to the specific slide
  const handleDotClick = (index) => {
    setVisibleIndex(index);
  };

  // Handle hover events to stop/start the auto-slide
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      className="relative w-full p-4 "
      onMouseEnter={handleMouseEnter} // Stop sliding on hover
      onMouseLeave={handleMouseLeave} // Resume sliding when hover ends
    >
      {/* Carousel Container */}
      <div className="relative overflow-hidden">
        {/* Slide Container */}
        <div
          ref={containerRef}
          className="flex transition-transform duration-2000 ease-in-out"
          style={{ width: '100%' }}
        >
          {groupedItems.map((group, index) => (
            <div
              key={index}
              className="flex w-full justify-center gap-4"
              style={{ minWidth: '100%' }} // Each group takes 100% width
            >
              {group.map((item, idx) => (
                <div
                  key={idx}
                  className={`bg-white min-h-48 flex-col p-4 flex-shrink-0 rounded-lg  hover:shadow-2xl hover:drop-shadow-xl hover:border-4 hover:border-gray-300  ${itemsPerSlide === 1 ? 'w-3/4' : 'w-1/4'}`}
                >
                  <div className="bg-white text-black font-bold flex flex-col gap-2 p-3">
                    <h1 className="text-lg font-semibold">{item.name}</h1>
                    <p className="font-light text-gray-600">
                      {item.description}
                    </p>
                    {/* <a href={item.link} className="text-blue-600 text-sm font-light underline">
                      Learn More
                    </a> */}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Dots for navigation */}
      <div className="flex justify-center mt-4 space-x-2">
        {groupedItems.map((_, index) => (
          <button
            key={index}
            className={`h-3 w-3 rounded-full ${index === visibleIndex ? 'bg-white' : 'bg-gray-400'}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default StringCarousel;
